// Login form functionality
// Extracted from devise/sessions/new.html.slim inline script

document.addEventListener('DOMContentLoaded', () => {
  const loginForm = document.getElementById('new_user')

  if (!loginForm) return

  const emailInput = document.getElementById('user_email')
  const passwordInput = document.getElementById('user_password')
  const loginButton = document.getElementById('login-button')
  const mercuryLoginButton = document.getElementById('mercury-login-button')

  if (!emailInput) return

  function updateButtonVisibility() {
    const username = emailInput.value

    // Check if username starts with "CA" (Mercury Capital identifier)
    const isMercuryUser = username && username.match(/^CA/)

    if (passwordInput) {
      passwordInput.style.display = isMercuryUser ? 'none' : ''
    }
    if (loginButton) {
      loginButton.style.display = isMercuryUser ? 'none' : ''
    }
    if (mercuryLoginButton) {
      mercuryLoginButton.style.display = isMercuryUser ? '' : 'none'
    }
  }

  emailInput.addEventListener('keyup', () => {
    updateButtonVisibility()
  })

  emailInput.addEventListener('change', () => {
    updateButtonVisibility()
  })

  // Handle form submission for Mercury users
  loginForm.addEventListener('submit', (e) => {
    const username = emailInput.value
    if (username && username.match(/^CA/)) {
      window.location.href = '/aver/auth/mercury'
      e.preventDefault()
      return false
    }
    return true
  })

  // Initial check on page load
  updateButtonVisibility()
})
